import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useHistory, useLocation, useRouteMatch } from 'react-router-dom';

function TaskDetailsPage({ route }) {
  const history = useHistory();
  const location = useLocation();
  const { taskId } = useRouteMatch().params;

  useEffect(() => {
    if (location.pathname === `/app/operational/tasks/${taskId}`) {
      history.push(`/app/operational/tasks/${taskId}/general`);
    }
  }, [location.pathname]);

  return null;
}

TaskDetailsPage.propTypes = {
  route: PropTypes.object.isRequired,
};

export default TaskDetailsPage;
